export const frontmatter = {
    "draft": false,
    "title": "Campaigns",
    "sidebar_group": "reference",
    "sidebar_label": "Campaigns",
    "sidebar_order": 9
}

export const toc = []